import { documentConstants } from "../_constants/documents.constants";
import moment from "moment";
// import { history } from "../_helpers";
import {DocumentApi, registrationService, userService} from "../_services";

export const documentActions = {
  loadAccountDocuments,
  loadLeadDocumentsByUser,
  getFileImgById,
  fetchDocumentByIdHash,
  markDocumentAsViewed,
  downloadDocument,
  documentUploadOnDone,
  isMyDocumentsEnabled,
};


function loadAccountDocuments(){
    return dispatch => {
        dispatch(loading());
        return DocumentApi.getDocumentsByUser()
            .then(response => {
                dispatch(success(response.data));
                dispatch(loading());
            })
            .catch(error => {
                dispatch(failure(error));
                dispatch(loading());
            });
    };
    function success(documents) {
        return {type: documentConstants.ACCOUNT_DOCUMENTS_SUCCESS, accountDocuments: documents }
    }
    function failure(errorString) {
        return { type: documentConstants.ACCOUNT_DOCUMENTS_FAILED, accountDocError: errorString };
    }
    function loading() {
        return {type: documentConstants.ACCOUNT_DOCUMENTS_LOADING}
    }
}

function loadLeadDocumentsByUser() {
   return (dispatch) => {
     dispatch(loading());
     return DocumentApi.getLeadDocumentsByUser()
       .then((response) => {
         if (response.httpResponseCode == 200 && response.data) {
           const { leadId , userHash} = response.data;
           const documentStatuses = response.data.documentStatuses
             .map((doc) => {
               if (moment(doc.creationTime) > moment(doc.modifiedTime)) {
                 doc.modifiedTime = doc.creationTime;
               }
               return doc;
             })
             .sort(
               (d1, d2) => moment(d2.modifiedTime) - moment(d1.modifiedTime)
             );

           const proofsOfIdentity = documentStatuses
             .filter(
               (s) =>
                 s.documentClassificationId ==
                 DocumentApi.DOCUMENT_CLASSIFICATION_IDENTITYFRONT
             )
             .slice(0, 1);
           const proofsOfResidence = documentStatuses.filter(
             (s) =>
               s.documentClassificationId ==
                 DocumentApi.DOCUMENT_CLASSIFICATION_RESIDENCE  
           )
           .slice(0,2);
           
           const proofsOfIncome = documentStatuses
             .filter(
               (s) =>
                 s.documentClassificationId ==
                 DocumentApi.DOCUMENT_CLASSIFICATION_INCOME
             ).slice(0,2);
             
           const getLeadDocumentsByUserResponse = {
             idDocuments: documentStatuses,
             proofsOfIdentity,
             proofsOfResidence,
             proofsOfIncome,
             leadId,
             userHash,
           };
           dispatch(success(getLeadDocumentsByUserResponse));
         }
         dispatch(loading());
         return response;
       })
       .catch((error) => {
         dispatch(failure(error));
         dispatch(loading());
         return error;
       });
   };
    function success(documents) {
        return {type: documentConstants.ID_DOCUMENTS_SUCCESS, leadDocuments: documents }
    }
    function failure(errorString) {
        return { type: documentConstants.ID_DOCUMENTS_FAILED, idDocError: errorString };
    }
    function loading() {
        return {type: documentConstants.ID_DOCUMENTS_LOADING}
    }
     
}

function getFileImgById(content) {
    const { id, documentTypeText } = content;
    return dispatch => {
        dispatch(loading())
        return DocumentApi.getFile(id)
            .then(res => {
                dispatch(success(res));
                dispatch(loading())
        })
            .catch(error => {
                dispatch(failure(error))
                dispatch(loading())
            })
    }
    function success(res) {
        let img = res.data;
        if (documentTypeText === "PDF") {
            img = "data:application/pdf;base64," + img;
        }
        return {type: documentConstants.FETCH_DOCUMENT_IMG_BY_ID_SUCCESS, documentImg: img }
    }
    function failure(errorString) {
        return { type: documentConstants.FETCH_DOCUMENT_IMG_BY_ID_FAILED, imgError: errorString };
    }
    function loading() {
        return {type: documentConstants.FETCH_DOCUMENT_IMG_BY_ID_LOADING}
    }
}


// Test URL: https://localhost:44367/Document/3D07FB4CCACB1046925D890231AD111D
// Social Security test Data: 333333399
// Date of birth Test Data: 1/15/1984
// should get this hash back: 5o578wOWcsLbJPax34Zq4t2LpmpxKrkMTv2J614lnVFDqRcpjO4aoaDaeIp/hNvnl75CPf5jzVUXX9sdQzaoZA==
//0 = Unknown, 1 = image, 2 = pdf)
function fetchDocumentByIdHash(data, urlHash) {
    let payLoad = {
        SSN: data.SocialSecurityNumber ? data.SocialSecurityNumber : data.IndividualTaxIdentificationNumber,
        DateOfBirth: data.DOB
    }
    return async dispatch => {
        dispatch(loading());
        try {
            let hashResponse = await registrationService.getUserHash(payLoad);

            if(hashResponse.httpResponseCode !== 200) {
                throw new Error(`Error Fetching Hash: status: ${hashResponse.status}`);
            }
            let documentIdPayLoad = {
                ReferenceToken : urlHash,
                UserHash: hashResponse.data
            }

            let documentIdResponseImg = await DocumentApi.getDocumentByIdToken(documentIdPayLoad);

            if(documentIdResponseImg.httpResponseCode !== 200) {
                throw new Error(`ERROR FETCHING DOCUMENT BY ID TOKEN: status: ${documentIdResponseImg.status}`);
            }
            if(!documentIdResponseImg.data.isValid) {
                throw new Error(`ERROR DOCUMENT INVALID : status ${documentIdResponseImg.status}`);
            }

            dispatch(success(documentIdResponseImg.data));
            dispatch(loading());
        } catch(error) {
            dispatch(failure(error));
            dispatch(loading());
            return error;
        }

    }
    function success(data) {
        if (data.documentType === 2) {
            data.document = "data:application/pdf;base64," + data.document;
        }
        return {type: documentConstants.FETCH_DOCUMENT_BY_HASH_ID_SUCCESS, data }
    }
    function failure(errorString) {
        return { type: documentConstants.FETCH_DOCUMENT_BY_HASH_ID_FAILED, errorString };
    }
    function loading() {
        return {type: documentConstants.FETCH_DOCUMENT_BY_HASH_ID_LOADING}
    }
}

function markDocumentAsViewed(doc) {
  return (dispatch) => {
    dispatch(loading(doc.id));    
    DocumentApi.getDocumentById(doc.id)
      .then((response) => {
        if (response.httpResponseCode == 200 && response.data) {
          const { data } = response;
          data.isViewed = true;
          DocumentApi.updateDocument(data)
            .then((result) => {
              dispatch(success(doc));
            })
            .catch((error) => {
                dispatch(failure(error));
                dispatch(loading());
            });
        }
        dispatch(loading());
      })
      .catch((error) => {
        dispatch(failure(error));
        dispatch(loading());
      });
  };
  function success(doc) {
    return {
      type: documentConstants.ID_DOCUMENTS_UPDATED_SUCCESS,
      documentUpdated: doc,
    };
  }
  function failure(errorString) {
    return {
      type: documentConstants.ID_DOCUMENTS_UPDATED_FAILED,
      idDocError: errorString,
    };
  }
  function loading(id=null) {
    return { type: documentConstants.ID_DOCUMENTS_UPDATED_LOADING,documentUpdatedId: id };
  }
}

function downloadDocument(doc) {
    return (dispatch) => { 
        dispatch(loading(doc.id)); 
        DocumentApi.getFile(doc.id).then((response) => {
            if (response.httpResponseCode == 200 && response.data){
                let link = document.createElement("a");
                link.href = "data:image/png;base64," + response.data;
                link.download = `${doc.documentName}`;
                link.click();
                setTimeout(function () {
                    window.URL.revokeObjectURL(link);
                }, 200);
                if (!doc.isViewed) {
                    dispatch(markDocumentAsViewed(doc))
                }else{
                    dispatch(loading()); 
                }
            }else{
                dispatch(loading()); 
            }
       
        }).catch(err=> dispatch(loading()))
        ;}
      function loading(id=null) {
        return { type: documentConstants.ID_DOCUMENTS_UPDATED_LOADING,documentUpdatedId: id };
      } 
  };

  function documentUploadOnDone(doc) {
    return (dispatch) => {
      const {FileName,ReceivedDateTime,DocumentClassification} = doc
      const documentUploaded = {
        id : "",
        documentClassificationId : DocumentClassification,
        documentStatusId : DocumentApi.DOCUMENT_STATUS_NEW,
        documentName : FileName,
        creationTime : ReceivedDateTime,
        modifiedTime : ReceivedDateTime,
        isViewed : false
      }
      dispatch(success(documentUploaded));
    };
    function success(documentUploaded) {
      return {
        type: documentConstants.ID_DOCUMENTS_UPLOAD_SUCCESS,
        documentUploaded,
      };
    }
  }
  function isMyDocumentsEnabled() {
    return (dispatch) => {
      return userService.isMyDocumentsEnabled().then(isMyDocumentsEnabled => {
        dispatch(success(isMyDocumentsEnabled));
      });
    };
    function success(isMyDocumentsEnabled) {
      return {
        type: documentConstants.IS_MY_DOCUMENTS_ENABLED_SUCCESS,
        isMyDocumentsEnabled,
      };
    }
  }